import { render, staticRenderFns } from "./OffenceCases.vue?vue&type=template&id=d3d6a846"
import script from "./OffenceCases.vue?vue&type=script&lang=js"
export * from "./OffenceCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports